export const gridDefaultColDef = {
  filter: 'agSetColumnFilter',
  resizable: true,
  sortable: true,
};

export function gridColumns(options) {
  const reviewersColDef = [];

  if (options.maxReviews === 0) {
    reviewersColDef.push({
      headerName: 'Reviewers',
      field: 'reviewers',
      flex: 1,
      wrapText: true,
      cellStyle: { display: 'flex', alignItems: 'center' },
      minWidth: 300,
      valueGetter: () => 'Not found',
    });
  }

  for (let i = 0; i < options.maxReviews; i++) {
    reviewersColDef.push({
      headerName: `Reviewer ${i + 1}`,
      field: `reviewer_${i + 1}`,
      flex: 1,
      wrapText: true,
      cellStyle: { display: 'flex', alignItems: 'center' },
      cellClass: (params) => {
        const { colDef, data } = params;
        const reviewer = data[colDef.field];

        if (reviewer?.isSubmitted) {
          return 'bg-secondary';
        }

        return '';
      },
      valueGetter: (params) => {
        const { colDef, data } = params;
        const reviewer = data[colDef.field];

        if (reviewer?.affiliate) {
          return reviewer.affiliate.name;
        }

        return '';
      },
    });
  }

  return [
    {
      headerName: 'Nominee',
      field: 'nominee',
      flex: 1,
      wrapText: true,
      autoHeight: true,
      cellClass: 'cursor-pointer',
      cellStyle: { display: 'flex', alignItems: 'center' },
      valueGetter: (params) => {
        const { nomination } = params.data;

        return nomination.identification;
      },
      minWidth: 200,
    },
    {
      headerName: 'Conflict',
      flex: 1,
      wrapText: true,
      cellClass: 'cursor-pointer',
      cellStyle: { display: 'flex', alignItems: 'center' },
      cellRenderer: options.conflictComponent,
      valueGetter: (params) => params.data,
      minWidth: 150,
    },
    ...reviewersColDef,
    {
      headerName: 'Grades',
      field: 'status',
      wrapText: true,
      cellStyle: { display: 'flex', alignItems: 'center' },
      valueGetter: (params) => {
        const { reviews } = params.data;

        if (reviews && reviews.length) {
          return reviews.map((r) => r.grade).join(' ');
        }

        return '--';
      },
      maxWidth: 180,
    },
    {
      headerName: 'Global Grade',
      field: 'status',
      wrapText: true,
      cellStyle: { display: 'flex', alignItems: 'center' },
      valueGetter: (params) => {
        const reports = params.data.nomination?.reports;

        if (reports && reports.length > 0) {
            const filtered = reports.filter((r) => r.reportable_type === 'nomination');

            if (filtered.length) {
              return filtered[0].global_grade;
            }
        }

        return '';
      },
      maxWidth: 150,
    },
    {
      headerName: 'Proposed',
      field: 'status',
      wrapText: true,
      cellStyle: { display: 'flex', alignItems: 'center' },
      valueGetter: () => 'No',
      maxWidth: 125,
    },
  ];
}
